import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

import style from '../sass/main.scss';

window.onCaptchaLoad = () => {
  ReactDOM.render(<App />, document.getElementById('app'));
}

const script = document.createElement('script');
script.setAttribute('src', `https://www.google.com/recaptcha/api.js?onload=onCaptchaLoad&render=${CAPTCHA_SITE_KEY}`);
document.head.appendChild(script);
